import { ConversationGroupFilters } from "domains/concierge/internal/types/ConversationGroupFilters";
import { ConversationGroupSortOptions } from "domains/concierge/internal/types/ConversationGroupSortOptions";
import { sha1 } from "object-hash";

export const conversationGroupId = (
    filters: ConversationGroupFilters,
    sortOptions: ConversationGroupSortOptions,
) => sha1({ filters, sortOptions });
